import { render } from "./CasePhotoSidebarContent.vue?vue&type=template&id=0736d5bb&ts=true"
import script from "./CasePhotoSidebarContent.vue?vue&type=script&lang=ts"
export * from "./CasePhotoSidebarContent.vue?vue&type=script&lang=ts"

import "./CasePhotoSidebarContent.vue?vue&type=style&index=0&id=0736d5bb&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__